module.exports = __webpack_public_path__ + "static/media/Linkedin.d66ee68f.svg";